import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboard = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 10,
	viewBox: "0 0 14 10",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1 0.5H0.5V1V9V9.5H1H13H13.5V9V1V0.5H13H1ZM1.5 8.5V1.5H12.5V8.5H1.5ZM11 3.25H10.5V4.25H11H11.01H11.51V3.25H11.01H11ZM4.5 5.75H5H9H9.5V6.75H9H5H4.5V5.75ZM10.5 5.75H11H11.01H11.51V6.75H11.01H11H10.5V5.75ZM2.5 5.75H3H3.01H3.51V6.75H3.01H3H2.5V5.75ZM3 3.25H2.5V4.25H3H3.01H3.51V3.25H3.01H3ZM4.5 3.25H5H5.01H5.51V4.25H5.01H5H4.5V3.25ZM7 3.25H6.5V4.25H7H7.01H7.51V3.25H7.01H7ZM8.5 3.25H9H9.01H9.51V4.25H9.01H9H8.5V3.25Z",
		fill: "currentColor"
	})
});
export default SvgKeyboard;
